<template>
  <div class="home">
    <el-container>
      <el-aside id="aside" :style="{ width: isCollapse ? '55px' : '240px' }">
        <!-- <el-radio-group v-model="isCollapse" style="margin-bottom: 20px;">
          <el-radio-button :label="false">展开</el-radio-button>
          <el-radio-button :label="true">收起</el-radio-button>
        </el-radio-group> -->

        <div
          style="padding: 16px 0 0 0; text-align: center"
          v-show="!isCollapse"
        >
          <!-- FIXME: 发布时打开 -->
          <img
            width="190"
            src="@/assets/images/index/icon_menu_logo.png"
            height="77"
          />
        </div>
        <div
          style="padding: 16px 0 0 0; text-align: center"
          v-show="isCollapse"
        >
          <img
            height="40"
            src="@/assets/images/index/icon_menu_logo_small.png"
          />
        </div>
        <div
          :class="isCollapse ? 'toggle-button-col' : 'toggle-button'"
          @click="isCollapse = !isCollapse"
        >
          |||
        </div>

        <el-menu
          default-active="home"
          class="el-menu-vertical-demo"
          @open="handleOpen"
          @close="handleClose"
          @select="selectMenu"
          :collapse="isCollapse"
          :collapse-transition="false"
          background-color="#103047"
          text-color="#069DBC"
          active-text-color="#FFF"
          unique-opened
        >
          <NavMenu :menuList="menuList"></NavMenu>
        </el-menu>
      </el-aside>
      <el-main>
        <div class="userPanel">
          <!-- <el-badge
            :value="notices"
            :class="{ 'itemL': notices>10,'item':notices<10|| notices==null}"
            :max="99"
          >
            <img src="@/assets/images/index/icon_notice.png" style="margin-top:0;"
            @click="gotoNotice"/>
          </el-badge>-->
          <img src="@/assets/images/index/icon_user_pic.png" />
          <el-dropdown trigger="click">
            <div class="el-dropdown-link userName">
              {{ userName }}&nbsp;&nbsp;
              <i class="el-icon-arrow-down"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="modifyPwd"
                >修改密码</el-dropdown-item
              >
              <el-dropdown-item @click.native="logout"
                >退出登录</el-dropdown-item
              >
              <el-dropdown-item @click.native="aboutVersion"
                >关于版本</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-tabs
          v-model="editableTabsValue"
          type="card"
          :closable="editableTabs.length > 1 ? true : false"
          :before-leave="beforeLeave"
          @tab-remove="removeTab"
          @contextmenu.native="openContextMenu($event)"
        >
          <el-tab-pane
            :key="item.name"
            v-for="item in editableTabs"
            :label="item.title"
            :name="item.name"
            class="tabpanel"
          >
            <com-loader
              :comObj="currentOpenComponent"
              :menuCode="menuCode"
              ref="comLoader"
            ></com-loader>
          </el-tab-pane>
        </el-tabs>
      </el-main>
    </el-container>
    <!-- 密码修改弹窗 -->
    <PwdSetting ref="PwdSetting" />

    <ul
      v-show="contextMenuVisible"
      :style="{ left: left + 'px', top: top + 'px' }"
      class="contextmenu"
    >
      <li @click="refresh">刷新</li>
      <li @click="closeTab('other')">除此之外全部关闭</li>
      <li @click="closeTab('current')">关闭</li>
    </ul>
  </div>
</template>

<script>
import langConfig from "../lang";
import NavMenu from "./navMenu/NavMenu";
import PwdSetting from "./systemSetting/PwdSetting";
import ComponentLoader from "../page/ComponentLoader";
import loaderMap from "../com-loader-map";
import { getAllMenuByUserCodeService } from "../services/sysSettingService";
import { loginOutOfPropertyService } from "../services/loginService";
import { h } from "vue";
export default {
  name: "Home",
  components: {
    NavMenu,
    PwdSetting,
    "com-loader": ComponentLoader,
  },
  data() {
    const colorValidator = (rule, value, callback) => {
      if (!value) {
        return callback(
          new Error(this.langConfig.validate.required[this.lang])
        );
      } else if (!/^#[\dabcdef]{6}$/i.test(value)) {
        return callback(new Error(this.langConfig.validate.format[this.lang]));
      } else {
        callback();
      }
    };
    return {
      isCollapse: false,
      colors: {
        primary: "#409eff",
      },
      rules: {
        primary: [{ validator: colorValidator, trigger: "blur" }],
      },
      originalStylesheetCount: -1,
      originalStyle: "",
      menuList: [], //菜单数据
      menuCode: "",
      editableTabsValue: "",
      editableTabs: [],
      tabIndex: 2,
      //tab右键菜单
      currentTab: "",
      contextMenuVisible: false,
      // mouseClickTab: "",
      left: 0,
      top: 0,
      userName: "",
      langConfig,
      primaryColor: "#409eff",
      //页面权限码
      pagePermissionCodes: {},
      fontFiles: ["element-icons.ttf", "element-icons.woff"],
      fonts: [],
      query: {
        name: "",
        date: [],
      },
      ws: undefined,
      timer: null,
    };
  },

  methods: {
    /* 获取菜单 */
    getUserMenu() {
      let requestParam = {
        // currentUserId: sessionStorage.getItem("currentUserId")
      };
      return getAllMenuByUserCodeService(requestParam).then(
        (res) => {
          if (res.code == 10000000) {
            res.data.forEach((menu) => {
              menu.isOpen = false;
              // let pic = menu.picURL.substring(0, menu.picURL.length - 4);
              // menu.activePicURL = pic + "_active.png";
            });
            this.menuList = res.data;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    beforeLeave(item) {
      this.currentTab = item;
      //顶部切换即将选中的tab
      this.bus.$emit("headerActiveTabName", item);
      //tab切换需要刷新页面
      // this.tabChangeNeedRefreshPage(item);
    },
    //tab右键菜单点击事件
    openContextMenu(e) {
      if (e.srcElement.id) {
        //超出header范围，不触发菜单显示
        if (e.clientY > 40) {
          this.closeContextMenu();
          return;
        }

        e.returnValue = false;
        if (this.editableTabs.length <= 1) {
          return;
        }
        // this.mouseClickTab = e.srcElement.id.split("-")[1];
        this.contextMenuVisible = true;
        this.left = e.clientX + 50;
        this.top = e.clientY + 10;
      } else {
        this.closeContextMenu();
      }
    },
    //关闭标签页
    closeTab(tag) {
      this.closeContextMenu();
      switch (tag) {
        case "other":
          this.editableTabs = this.editableTabs.filter(
            (tab) => tab.name === this.currentTab
          );
          this.editableTabsValue = this.currentTab;
          break;
        case "current":
          this.removeTab(this.currentTab);
          break;
        default:
          break;
      }
    },
    // 刷新当前页面
    refresh() {
      this.closeContextMenu();
      let index = this.getCurrentTabIndex();
      // console.log('刷新页面index：' + index);
      if (this.$refs.comLoader.length > index) {
        const tab = this.editableTabs[index];
        let menuCode = this.getPagePermissionCode(tab.navIndex);
        this.$refs.comLoader[index].refreshPage(menuCode);
      }
    },
    //刷新对应页面
    refreshPageWithName(tabName) {
      let tabs = this.editableTabs;
      tabs.forEach((tab, index) => {
        if (tab.name === tabName) {
          if (this.$refs.comLoader.length > index) {
            let menuCode = this.getPagePermissionCode(tab.navIndex);
            this.$refs.comLoader[index].refreshPage(menuCode);
          }
          return;
        }
      });
    },
    //tab切换需要刷新页面
    tabChangeNeedRefreshPage(name) {
      setTimeout(() => {
        if (name === "业主工单新增情况") {
          this.refresh();
        }
      }, 600);
    },
    //获取当前显示index
    getCurrentTabIndex() {
      let currentT = this.currentTab;
      for (let i = 0; i < this.editableTabs.length; i++) {
        const tab = this.editableTabs[i];
        if (tab.name == currentT) {
          return i;
        }
      }
      return 0;
    },
    // 关闭contextMenu
    closeContextMenu() {
      this.contextMenuVisible = false;
    },
    /**
     * tab标签关闭行为
     * @param
     * targetName   String      关闭的标签的名称
     **/
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      // if (activeName === targetName) {
      tabs.forEach((tab, index) => {
        if (tab.name === targetName) {
          let nextTab = tabs[index + 1] || tabs[index - 1];
          if (nextTab) {
            activeName = nextTab.name;
          }
        }
      });
      // }
      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
    },
    /* 密码修改弹窗 */
    modifyPwd() {
      this.$refs.PwdSetting.showPwdDialog(sessionStorage.getItem("userCode"));
    },
    /* 退出登录按钮事件 */
    logout(e) {
      this.$confirm("确认要退出当前用户吗？", "提示", {
        confirmButtonText: "确定",
        type: "warning",
      }).then(() => {
        //调用退出
        loginOutOfPropertyService().then((res) => {
          sessionStorage.clear();
          this.$router.push({ name: "login" });
        });
      });
    },
    /* 展示简要的发版信息,包括日期，更新内容 */
    aboutVersion() {
      let arr = [
        "2024-1-23 更新内容：",
        "发票模块新需求上线",
      ];
      let msg = arr.join(" <br/> ");
      this.$alert(msg, "关于版本", {
        confirmButtonText: "确定",
        dangerouslyUseHTMLString: true,
      });
    },
    /**
     * tab标签增加打开行为
     * @param
     * navIndex   String          当前navMenu选中的菜单项索引
     * tabRouteParam   Object     页面传参数
     * tabRouteParam   String     页面唯一编号，用于页面多开
     **/
    addTabAction(navIndex, tabRouteParam = "", pageId = "") {
      let { title, name, component } = loaderMap[navIndex];

      let openedTab = this.editableTabs.filter((val) => val.name == name);
      if (openedTab.length) {
        this.menuCode = openedTab[0].menuCode;
        if (navIndex == openedTab[0].navIndex) {
          this.editableTabsValue = name;
          this.comLoaderActive(component, tabRouteParam, name, navIndex);
          return;
        } else {
          this.bus.$emit("tabClose", openedTab[0].navIndex, pageId);
          setTimeout(() => {
            this.addTabAction(navIndex, tabRouteParam, pageId);
          }, 1);
          return;
        }
      }

      this.editableTabs.push({
        navIndex,
        title,
        name,
        menuCode: this.menuCode,
      });

      this.editableTabsValue = name;
      this.currentOpenComponent = loaderMap[navIndex];
      this.currentOpenComponent.uniCode = name;
      this.$nextTick(() => {
        this.comLoaderActive(component, tabRouteParam, name, navIndex);
      });
    },

    comLoaderActive(comName, tabRouteParam, uniCode, navIndex) {
      let activeCom = this.$refs.comLoader.find(
        (vueCom) => vueCom.useCom === comName && vueCom.uniCode === uniCode
      );
      let menuCode = this.getPagePermissionCode(navIndex);
      activeCom.comActiveAction(comName, tabRouteParam, menuCode);
    },
    /*
     * 菜单事件
     */
    //获取页面权限code
    getPagePermissionCode(component) {
      //先取缓存
      let pagePerCode = this.pagePermissionCodes[component];
      if (pagePerCode && pagePerCode.length > 0) {
        //  console.log('1111缓存获取 当前页面code码为： ' + pagePerCode);
        return pagePerCode;
      } else {
        // 没有记录则去遍历菜单
        pagePerCode = this.findMenuPermCode(this.menuList, component);
        if (null != pagePerCode && pagePerCode.length > 0) {
          this.pagePermissionCodes[component] = pagePerCode.id;
        }
        // console.log('2222 当前页面code码为： ' + pagePerCode);
        return pagePerCode;
      }
    },
    //获取菜单按钮权限
    findMenuPermCode(menuList, component) {
      if (menuList.length > 0) {
        for (let i = 0; i < menuList.length; i++) {
          let menu = menuList[i];
          if (menu.component == component) {
            return menu;
          } else {
            if (null != menu.subMenuList) {
              if (menu.subMenuList.length > 0) {
                let menuId = this.findMenuPermCode(menu.subMenuList, component);
                if (menuId) {
                  return menuId;
                }
              }
            }
          }
        }
      } else {
        return null;
      }
    },
    handleOpen(key) {
      this.menuList.forEach((menu) => {
        if (menu.id == key) menu.isOpen = true;
        else menu.isOpen = false;
      });
    },
    handleClose(key) {
      this.menuList.forEach((menu) => {
        if (menu.id == key) menu.isOpen = false;
      });
    },
    selectMenu(key) {
      this.menuCode = key;
      let menu = this.findMenu(this.menuList, key);
      this.bus.$emit("navMenuChange", menu.component);
    },
    findMenu(menuList, menuCode) {
      for (let i = 0; i < menuList.length; i++) {
        let menu = menuList[i];
        if (menu.id == menuCode) {
          return menu;
        } else {
          if (null != menu.subMenuList) {
            if (menu.subMenuList.length > 0) {
              let menuFind = this.findMenu(menu.subMenuList, menuCode);
              if (menuFind) return menuFind;
            }
          }
        }
      }
    },
  },
  beforeCreate() {
    this.bus.$on("navMenuChange", (nav) => {
      let navIndex, routePatam, pageId;
      if (typeof nav === "object" && typeof nav != undefined) {
        navIndex = nav.routeId;
        routePatam = nav.routeParam;
        pageId = nav.pageId;
      } else {
        navIndex = nav;
      }
      this.addTabAction(navIndex, routePatam, pageId);
    });

    this.bus.$on("tabClose", (navName, pageId = "") => {
      if (loaderMap[navName]) {
        let tabName = loaderMap[navName].name;
        tabName += pageId;
        this.removeTab(tabName);
      } else {
        console.warn(`未找到${navName}对应tab页面,请检查com-loader-js配置文件`);
      }
    });

    this.bus.$on("tabRefresh", (navName, pageId = "") => {
      let tabName = loaderMap[navName].name;
      tabName += pageId;
      tabName
        ? this.refreshPageWithName(tabName)
        : console.warn(
            `未找到${navName}对应tab页面,请检查com-loader-js配置文件`
          );
    });
  },
  watch: {
    // editableTabsValue(name) {},
    editableTabs(tabs) {
      this.showIndexPage = tabs.length < 1;
    },
    contextMenuVisible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeContextMenu);
      } else {
        document.body.removeEventListener("click", this.closeContextMenu);
      }
    },
  },
  created() {
    this.getUserMenu();
    this.userName = sessionStorage.getItem("name");
    this.store.set("tabRouteParam", {});
    if (sessionStorage.getItem("supplierId") == 0) {
      this.bus.$emit("navMenuChange", {
        routeId: "workbench",
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },

  mounted() {
    this.$nextTick(() => {
      this.originalStylesheetCount = document.styleSheets.length;
    });

    let name = sessionStorage.getItem("login-name");

    let wsUrl = window.wsUrl;
    if (wsUrl && "WebSocket" in window) {
      this.ws = new WebSocket(wsUrl + name);
      let that = this;
      this.ws.onopen = function (evt) {
        // console.log("ws open", evt);
        clearInterval(that.timer);
        that.timer = setInterval(() => {
          // console.log("ws HeartBeat");
          if (that&&that.ws) that.ws.send("HeartBeat");
        }, 8000); // 发送心跳消息的时间间隔，单位毫秒
      };
      this.ws.onclose = function (evt) {
        console.log("ws close", evt);
      };
      let self = this;
      this.ws.onmessage = function (evt) {
        // console.log("ws收到消息");
        self.$notify({
          title: "通知",
          message: "您有一条新消息，请前往消息中心查收",
          type: "success",
        });
      };
      this.ws.onerror = function (evt) {
        if ("WebSocket" in window) {
          this.ws = new WebSocket(wsUrl + name);
        } else {
          alert("该浏览器不支持websocket");
        }
      };
    }
  },
  beforeDestroy() {
    this.bus.$off("navMenuChange");
    if (this.ws) {
      this.ws.close();
      this.ws = undefined;
    }
  },
};
</script>

<style scoped lang="scss">
.home {
  height: 100%;
  width: 100%;
  // overflow: hidden;
  // display: flex;
  // flex-direction: column;
  background-color: #e9f4fa;
  .el-container {
    height: 100%;
  }
  .el-aside {
    height: 100%;
    background-color: #103047;
    // /deep/.el-submenu.is-active .el-submenu__title {
    //   color: #fff !important;
    // }
    /deep/.el-menu {
      border-right: none;
    }
    /deep/.el-menu-item.is-active {
      background: #069dbc !important;
    }
    .toggle-button {
      margin-top: 16px;
      line-height: 30px;
      text-align: center;
      background-color: #e4e7ed38;
      color: white;
      cursor: pointer;
      letter-spacing: 0.2em;
      font-size: 14px;
    }
    .toggle-button-col {
      margin-top: 16px;
      line-height: 30px;
      text-align: center;
      background-color: #e4e7ed38;
      color: white;
      cursor: pointer;
      letter-spacing: 0.1em;
      font-size: 10px;
    }
    /deep/.el-menu--collapse {
      width: 84px;
    }
  }
  .el-aside::-webkit-scrollbar {
    display: none;
  }
  .contextmenu {
    width: 150px;
    margin: 0;
    border: 1px solid #ccc;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.2);
    text-align: left;
  }
  .contextmenu li {
    margin: 0;
    padding: 7px 16px;
  }
  .contextmenu li:hover {
    background: #f2f2f2;
    cursor: pointer;
  }
}

/deep/.el-main {
  // padding: 0;
  // overflow: hidden;
  > .el-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;
    .el-tabs__nav {
      .el-icon-close:before {
        color: #069dbc;
        font-size: 16px;
      }
    }
    > .el-tabs__content {
      height: 100%;
      display: flex;
      flex-direction: column;
      > .el-tab-pane {
        //height: 100%;
        height: calc(100% - 20px);
        // background: #e9f4fa;
        padding: 10px;
        display: flex;
        flex-direction: column;
      }
    }
  }
}

.el-main {
  padding: 0;
  position: relative;
  .item {
    margin-right: 18px;
  }
  .itemL {
    margin-right: 24px;
  }
  /deep/.el-badge__content.is-fixed {
    top: 10px;
  }

  // overflow: hidden;
  .userPanel {
    position: absolute;
    right: 0;
    top: 0;
    height: 40px;
    line-height: 40px;
    z-index: 10;
    font-size: 14px;
    vertical-align: middle;
    max-width: 250px;
    display: flex;
    min-width: 100px;
    .el-popper {
      min-width: 100px;
    }

    .userName {
      padding: 0 10px;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 150px;
      flex: 1;
    }
    img {
      vertical-align: middle;
      width: 24px;
      height: 24px;
      margin-top: 8px;
    }
  }
}
/deep/.el-tabs--card > .el-tabs__header .el-tabs__item {
  border-bottom: none;
}
// /deep/.el-tabs__nav {
//   /deep/.el-icon-close:before {
//     color: #069dbc;
//     font-size: 16px;
//   }
// }

.el-checkbox__inner {
  border: 1px solid #bababa !important;
}

.el-header {
  // height: 117px;
  width: 100%;
  padding: 0;
  // background-color: #103047;
}
/deep/.el-tabs__header {
  margin: 0;
  background-color: #fff;
  padding-right: 200px;
}
/deep/.el-tabs__item {
  color: #069dbc;
}
/deep/.el-tabs__item.is-top.is-active {
  //background-color: transparent !important;
  color: #069dbc;
}
/deep/.el-tabs__item.is-active.is-closable {
  background-color: #e9f4fa !important;
}

/deep/.el-button--text {
  color: #079dbd;
}
/deep/.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #079dbd;
  color: #ffffff;
}
</style>
